import ApiRequest from "../index"

const complementsExchanges = {
    get: async data => ApiRequest.get(`/v2/lojinha/complements/exchanges`),
    put: async data => ApiRequest.put(`/v2/lojinha/complements/exchanges`,{...data}),
}

export default complementsExchanges